import React, { useEffect, useId, useRef, useState } from 'react';
import { Dropdown } from 'antd';
import AntdProvider from './AntdProvider';

/** Native button activation plus antd's arrow-key menu navigation. */
export default function NavbarDropdown({ label, items, selectedKeys = [], className = '' }) {
  const [open, setOpen] = useState(false);
  const trigger = useRef(null);
  const menuId = useId();

  useEffect(() => {
    const queries = ['(min-width: 900px)', '(min-width: 1440px)'].map((query) => window.matchMedia(query));
    const close = () => setOpen(false);
    queries.forEach((query) => query.addEventListener('change', close));
    return () => queries.forEach((query) => query.removeEventListener('change', close));
  }, []);

  const onKeyDown = (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopPropagation();
      setOpen(false);
      trigger.current?.focus();
    }
  };

  return (
    <AntdProvider>
      <Dropdown
        trigger={['click']}
        open={open}
        onOpenChange={setOpen}
        autoFocus
        destroyPopupOnHide
        overlayClassName="navbar-popup"
        menu={{
          id: menuId,
          items,
          selectedKeys,
          onClick: () => setOpen(false),
          onKeyDownCapture: onKeyDown,
          'aria-label': label,
        }}
      >
        <button
          ref={trigger}
          type="button"
          className={`nav-dropdown-btn ${className}`.trim()}
          aria-label={label === 'More' ? 'More navigation' : label}
          aria-haspopup="menu"
          aria-expanded={open}
          aria-controls={open ? menuId : undefined}
          onKeyDown={(event) => {
            if (['Enter', ' ', 'ArrowDown'].includes(event.key)) {
              event.preventDefault();
              setOpen(true);
            }
            onKeyDown(event);
          }}
        >
          {label}<span className="nav-dropdown-chevron" aria-hidden="true">▾</span>
        </button>
      </Dropdown>
    </AntdProvider>
  );
}
